import { Link } from "react-router-dom";
import useDocumentTitle from "../lib/useDocumentTitle";

export default function NotFound({ title = "Stránka nenalezena", text = "Odkaz je možná zastaralý nebo neúplný." }) {
  useDocumentTitle(title);
  return (
    <div className="container section" style={{ textAlign: "center", minHeight: "55vh" }}>
      <p className="eyebrow">404</p>
      <h1 className="h2" style={{ marginTop: 12 }}>{title}</h1>
      <p className="muted" style={{ marginTop: 12 }}>{text}</p>
      <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 28 }}>
        <Link to="/nabidka" className="btn btn-primary">Skladové vozy</Link>
        <Link to="/" className="btn btn-ghost">Na úvod</Link>
      </div>
    </div>
  );
}
